import { Bookmark, Dashboard, Description, Help, List } from '@material-ui/icons'
import React from 'react'

export default function getResourceIconFromType(type, props) {
  if(type === 'document') {
    return <Description {...props}/>;
  }else if(type === 'term') {
    return <Bookmark {...props}/>
  }else if(type === 'index') {
    return <Dashboard {...props}/>
  }else if(type === 'collection') {
    return <List {...props}/>/*TODO replace with VerticalSplit once released*/
  }
  else return <Help {...props}/>
}


// WEBPACK FOOTER //
// ./src/utils/ResourceIconFromType.js